import { Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import PropTypes from "prop-types";

const useStyles = makeStyles((theme) => ({
  draft: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    background: theme.palette.common.draftBg,
    color: "white",
    borderRadius: theme.spacing(2),
    height: 30,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: 60,
    "&.MuiTypography-root": {
      fontSize: 16,
      fontWeight: 500,
    },
  },
  ready: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    background: theme.palette.common.greenTxt,
    color: "white",
    borderRadius: theme.spacing(2),
    height: 30,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: 60,
    "&.MuiTypography-root": {
      fontSize: 16,
      fontWeight: 500,
    },
  },
  free: {
    color: theme.palette.common.greenTxt,
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    "&.MuiTypography-root": {
      fontSize: 14,
      fontWeight: 500,
    },
  },
  paid: {
    color: theme.palette.common.redTxt,
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    "&.MuiTypography-root": {
      fontSize: 14,
      fontWeight: 500,
    },
  },
}));

export function StatusLabel(props) {
  const classes = useStyles();
  const { children, type } = props;

  return <Typography className={classes[type]}>{children}</Typography>;
}

StatusLabel.propTypes = {
  type: PropTypes.string,
};
